export const landlordStatus = {
  ONBOARDING: 'ONBOARDING',
  PENDING: 'PENDING',
  VERIFIED: 'VERIFIED',
};

export const landlordSystemProvider = [
  'ENTRATA',
  'KINETIC',
  'ON_SITE',
  'ONESITE',
  'PEX',
  'STAR_REZ',
  'TCAS',
  'OWN_SYSTEM',
  'BUILD_IN_HOUSE_LAMS',
  'BUILT_IN_HOUSE',
  'GRADPAD',
  'LEASE_HAWK',
  'ONESITE_YARDI',
  'ROOM_SERVICE_OCCAM',
  'SEARCH_QUEST',
  'SIRVOY',
  'STU_RENTS',
  'OCCAM',
  'APP_FOLIO',
  'REAL_PAGE',
  'NO_SYSTEM',
  'SALES_FORCE',
  'RENT_CAFE',
  'YARDI',
  'TENANT_CLOUD',
  'OTHER',
  'RENTMANAGER',
  'RES_MAN',
  'INNSOFT',
  'SYNXIS',
  'SITEMINDER',
  'MRI_SOFTWARE',
  'LEASE_LABS',
  'CLOUDBEDS',
];

export const landlordReconciliationPreference = ['LANDLORD_PORTAL', 'EMAIL_CSV', 'NOT_SPECIFIC'];

export const propertyDisabledReasons = {
  PUBLISHED: 'published',
  LINKED: 'linked',
  NOT_KEY: 'notKey',
};

export const paymentPlanCategoryType = {
  DEPOSIT_IS_REQUIRED: 'DEPOSIT_IS_REQUIRED',
  RENT_IS_REQUIRED: 'RENT_IS_REQUIRED',
};
